import { render } from "./ChangeLogModal.vue?vue&type=template&id=31a0b8be&scoped=true"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js"

import "./ChangeLogModal.vue?vue&type=style&index=0&id=31a0b8be&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a0b8be"]])

export default __exports__